// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"institution-checked"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M2 7L11 2L20 7V8H2V7Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M11 12V18M5 12V18M11 22H2M17 12V16M2 7V8H20V7L11 2L2 7Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M21.1823 17.9395L16.9397 22.1821L14.8184 20.0608","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-institution-checked')
export default class InstitutionCheckedIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'institution-checked',
    }
  }
}
